import { NativeModules } from 'react-native';

const { Geouniq } = NativeModules;

export default Geouniq as GeouniqType;
